module.exports = __webpack_public_path__ + "static/media/sports-and-competition.fb82b626.svg";